import { GoogleCallbackRequest } from "@domain/auth/auth";

export function googleTokensFromFragment(fragment: string): GoogleCallbackRequest | null {
  const params = new URLSearchParams(fragment.replace(/^#/, ""));
  const accessToken = params.get("access_token");
  if (!accessToken) return null;

  const refreshToken = params.get("refresh_token");
  return refreshToken ? { accessToken, refreshToken } : { accessToken };
}
